import { Col } from 'antd';
import UserStatusDropdown from 'common/reference-data/containers/user-status-dropdown-container';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Div, FormItem, FormText, Input, Row, SapId } from 'ui';
import { referenceTypes } from '../../../utils/app-configs';

const General = ({
  data: {
    number,
    name,
    statuses = [],
    typeDescription,
    contractType,
    age,
    manufacturer,
    projectDescription,
    projectNumber,
  },
  form,
  setFormDirty,
  intl,
  isEditable,
  disabled,
  userStatuses = [],
}) => {
  const onStatusesChanged = (selectedStatuses) => {
    form.setFieldsValue({ statuses: selectedStatuses });
  };

  const nameValidator = form.getFieldDecorator('name', {
    initialValue: name,
  });

  const statusesValidator = form.getFieldDecorator('statuses', {
    initialValue: statuses || [],
  });

  return (
    <Div data-test-id='info-general' marginBottom={20}>
      <Row type='flex' gutter={16} marginRight={0}>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.DESCRIPTION' })}>
            {isEditable ?
              nameValidator(<Input disabled={disabled} />)
              :
              <FormText data-test-id='info-name'>{name}</FormText>
            }
          </FormItem>
        </Col>
        <Col md={12} sm={24} xs={24} data-test-id='info-number'>
          <FormItem
            label={intl.formatMessage({ id: 'functionalLocation.general.FUNCTIONALLOCATION_NR' })}
          >
            {/* use the ID component to tansform to 'readable' ID (without leading zeroes) */}
            <SapId originalId={number}>{id => <FormText>{id}</FormText>}</SapId>
          </FormItem>
        </Col>
      </Row>
      <Row type='flex' gutter={16}>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.STATUS' })}>
            {isEditable ?
              statusesValidator(
                <UserStatusDropdown
                  type={referenceTypes.functionallocation}
                  onStatusesChanged={onStatusesChanged}
                  originalStatuses={statuses}
                  disabled={disabled}
                  userStatuses={userStatuses}
                  setFormDirty={setFormDirty}
                />,
              )
              :
              <FormText>{statuses?.map(s => s.id)?.join(', ')}</FormText>
            }
          </FormItem>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.TYPE' })}>
            <FormText>{typeDescription}</FormText>
          </FormItem>
        </Col>
      </Row>
      <Row type='flex' gutter={16}>
        <Col md={12} sm={24} xs={24} data-test-id='info-contract'>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.CONTRACT' })}>
            <FormText>{contractType}</FormText>
          </FormItem>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.MANUFACTURER' })}>
            <FormText>{manufacturer}</FormText>
          </FormItem>
        </Col>
      </Row>
      <Row type='flex' gutter={16}>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.AGE' })}>
            <FormText>
              {`${intl.formatNumber(age || 0, { maximumFractionDigits: 2 })} year(s)`}
            </FormText>
          </FormItem>
        </Col>
      </Row>
      <Row type='flex' gutter={16}>
        <Col md={12} sm={24} xs={24}>
          <FormItem label={intl.formatMessage({ id: 'functionalLocation.general.PROJECT_NUMBER' })}>
            <FormText>{projectNumber}</FormText>
          </FormItem>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <FormItem
            label={intl.formatMessage({ id: 'functionalLocation.general.PROJECT_DESCRIPTION' })}
          >
            <FormText>{projectDescription}</FormText>
          </FormItem>
        </Col>
      </Row>
    </Div>
  );
};

General.propTypes = {
  data: PropTypes.object,
  isEditable: PropTypes.bool,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
  setFormDirty: PropTypes.func,
  userStatuses: PropTypes.array,
};

export default injectIntl(General);
